import { ExportedData, ExportQueryParams } from '@breathelife/types';

import ApiService from './ApiService';

export async function fetchDataForExport(query: ExportQueryParams): Promise<ExportedData> {
  const { data } = await ApiService.admin.fetchDataForExport(query);
  return data;
}
